export enum BdmBatchFileStatus {
  IMPORTING = 'IMPORTING',
  READY_TO_SUBMIT = 'READY_TO_SUBMIT',
  CANCEL = 'CANCEL',
  SUBMITTED = 'SUBMITTED',
}

export const bdmBatchFileStatuses = [
  {
    code: BdmBatchFileStatus.IMPORTING,
    label: 'opm_pd.processing',
    color: 'warning',
  },
  {
    code: BdmBatchFileStatus.READY_TO_SUBMIT,
    label: 'opm_pd.readyToSubmit',
    color: 'info',
  },
  {
    code: BdmBatchFileStatus.CANCEL,
    label: 'opm_pd.cancel',
    color: 'error',
  },
  {
    code: BdmBatchFileStatus.SUBMITTED,
    label: 'opm_pd.submitted',
    color: 'success',
  },
];

export const bdmBatchFileStatusMap = bdmBatchFileStatuses.reduce((acc, status) => {
  acc[status.code] = status;
  return acc;
}, {} as Record<string, { code: BdmBatchFileStatus; label: string; color: string }>);

export enum PolicyTaskStatus {
  AWAITING_SUBMIT = 'AWAITING_SUBMIT',
  AWAITING_LM = 'AWAITING_LM',
  AWAITING_ADMIN = 'AWAITING_ADMIN',
  AWAITING_QC = 'AWAITING_QC',
  REJECT_LM = 'REJECT_LM',
  REJECT_ADMIN = 'REJECT_ADMIN',
  REJECT_QC = 'REJECT_QC',
  END_BDM = 'END_BDM',
  END_SYSTEM = 'END_SYSTEM',
  DONE = 'DONE',
  HOLD = 'HOLD',
  TRANSFERRED = 'TRANSFERRED',
  TRANSFER_FAIL = 'TRANSFER_FAIL',
  CANCEL = 'CANCEL',
}

export const policyTaskStatuses = [
  {
    code: PolicyTaskStatus.AWAITING_SUBMIT,
    label: PolicyTaskStatus.AWAITING_SUBMIT,
    color: 'primary',
  },
  {
    code: PolicyTaskStatus.AWAITING_LM,
    label: PolicyTaskStatus.AWAITING_LM,
    color: 'primary',
  },
  {
    code: PolicyTaskStatus.AWAITING_ADMIN,
    label: PolicyTaskStatus.AWAITING_ADMIN,
    color: 'primary',
  },
  {
    code: PolicyTaskStatus.AWAITING_QC,
    label: PolicyTaskStatus.AWAITING_QC,
    color: 'primary',
  },
  {
    code: PolicyTaskStatus.REJECT_LM,
    label: PolicyTaskStatus.REJECT_LM,
    color: 'primary',
  },
  {
    code: PolicyTaskStatus.REJECT_ADMIN,
    label: PolicyTaskStatus.REJECT_ADMIN,
    color: 'primary',
  },
  {
    code: PolicyTaskStatus.REJECT_QC,
    label: PolicyTaskStatus.REJECT_QC,
    color: 'primary',
  },
  {
    code: PolicyTaskStatus.DONE,
    label: 'APPROVED',
    color: 'primary',
  },
  {
    code: PolicyTaskStatus.HOLD,
    label: PolicyTaskStatus.HOLD,
    color: 'success',
  },
  {
    code: PolicyTaskStatus.END_BDM,
    label: PolicyTaskStatus.END_BDM,
    color: 'info',
  },
  {
    code: PolicyTaskStatus.END_SYSTEM,
    label: PolicyTaskStatus.END_SYSTEM,
    color: 'error',
  },
  {
    code: PolicyTaskStatus.TRANSFERRED,
    label: 'DONE',
    color: 'primary',
  },
  {
    code: PolicyTaskStatus.TRANSFER_FAIL,
    label: PolicyTaskStatus.TRANSFER_FAIL,
    color: 'error',
  },
  {
    code: PolicyTaskStatus.CANCEL,
    label: PolicyTaskStatus.CANCEL,
    color: 'error',
  },
];

export const policyTaskStatusMap = policyTaskStatuses.reduce((acc, status) => {
  acc[status.code] = status;
  return acc;
}, {} as Record<string, { code: PolicyTaskStatus; label: string; color: string }>);

export enum BdmSentBackFromCode {
  LM = 'LM',
  ADMIN = 'ADMIN',
  NO_QUALIFIED_AGENT = 'NO_QUALIFIED_AGENT',
  QC = 'QC',
}

export const bdmSentBackFromCodes = [
  {
    code: BdmSentBackFromCode.LM,
    label: 'opm_pd.sentBackFromLineManager',
  },
  {
    code: BdmSentBackFromCode.ADMIN,
    label: 'opm_pd.sentBackFromAdmin',
  },
  {
    code: BdmSentBackFromCode.NO_QUALIFIED_AGENT,
    label: 'opm_pd.noQualifiedAgent',
  },
  {
    code: BdmSentBackFromCode.QC,
    label: 'opm_pd.sentBackFromQc',
  },
];

export const bdmSentBackFromCodeMap = bdmSentBackFromCodes.reduce((acc, status) => {
  acc[status.code] = status;
  return acc;
}, {} as Record<string, { code: BdmSentBackFromCode; label: string }>);

export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [50, 100, 200, 500];
